import React from 'react';
import { SafeComponent } from '@fiverr-private/orca';
import { Container } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';
import VideoHeroBanner from '../VideoHeroBanner';
import Hero from '../Hero';
import { useIsMobileLayout } from '../../../../shared/hooks/useIsMobileLayout';
import { isAllocated } from '../../utils/experiments';
import { LYNXES_EXPANDABLE_SEARCH_BAR } from '../../utils/experiments/experimentsEnum';

const VideoHeroBannerWrapper = ({ inExpandableSearchBar = false }: { inExpandableSearchBar?: boolean }) => {
  const isMobileLayout = useIsMobileLayout(['default', 'sm']);

  const { abTests } = getContext();
  const shouldUseExpandableSearchBar = isAllocated(LYNXES_EXPANDABLE_SEARCH_BAR, abTests) && inExpandableSearchBar;

  return (
    <>
      <Container display={{ default: 'none', md: 'block' }}>
        <VideoHeroBanner shouldLoadVideo={!isMobileLayout} inExpandableSearchBar={shouldUseExpandableSearchBar} />
      </Container>
      <Container display={{ default: 'block', md: 'none' }}>
        <Hero />
      </Container>
    </>
  );
};

export default SafeComponent(VideoHeroBannerWrapper);
